import { render } from "./WorkInfo.vue?vue&type=template&id=0d9de5d2"
import script from "./WorkInfo.vue?vue&type=script&lang=js"
export * from "./WorkInfo.vue?vue&type=script&lang=js"

import "./WorkInfo.vue?vue&type=style&index=0&id=0d9de5d2&lang=scss"

import exportComponent from "/home/wf13/Develop/web/vue-portfolio/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__